import { brokers } from '@/data/brokers';

export default function FeaturedBrokersGrid() {
  return (
    <section
      id="featured-brokers"
      className="w-full py-20 md:py-28 bg-background-50"
    >
      <div className="w-full max-w-main mx-auto px-4 md:px-6">
        {/* Section Header — framed as a natural next step after learning costs */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-[30px] md:text-[40px] font-[750] leading-[38px] md:leading-[48px] text-foreground-950 tracking-[-0.015em]">
            Where to Apply What You've Learned
          </h2>
          <p className="mt-4 text-[16px] md:text-[17px] leading-[28px] md:leading-[30px] text-foreground-600 max-w-[680px] mx-auto">
            Every broker structures costs differently. Use the knowledge from above to compare spreads, commissions, and conditions — these are a few widely-used brokers to start your research.
          </p>
        </div>

        {/* Broker Cards — clean comparison cards, not ad units */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {brokers.map((broker) => (
            <a
              key={broker.name}
              href={broker.href}
              target="_blank"
              rel="sponsored nofollow noopener"
              className="group flex flex-col bg-white rounded-2xl p-5 md:p-6 no-underline transition-all duration-300 hover:-translate-y-1 border border-background-200/80 hover:border-foreground-200"
            >
              {/* Broker Name + subtle ad indicator */}
              <div className="flex items-center justify-between mb-1">
                <h3 className="text-[20px] font-[700] leading-[26px] text-foreground-950">
                  {broker.name}
                </h3>
                <span className="text-[10px] text-foreground-400 tracking-wide bg-background-100 px-2 py-0.5 rounded-full">
                  Ad
                </span>
              </div>

              {/* Highlight selling point */}
              <p className="mt-2 text-[13.5px] font-semibold leading-[19px] text-primary-600">
                {broker.highlight}
              </p>

              {/* Description — informative, not sales-y */}
              <p className="mt-2.5 text-[13.5px] leading-[20px] text-foreground-600 flex-1">
                {broker.benefit}
              </p>

              {/* Quick stats row */}
              <div className="mt-4 flex items-center gap-3 text-[12px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-shield-check-line text-[13px] text-foreground-400"></i>
                  {broker.regulation.split(',')[0]}
                </span>
                <span className="text-foreground-300">·</span>
                <span>Min {broker.minDeposit}</span>
              </div>

              {/* CTA — softer language */}
              <span className="mt-4 flex items-center justify-center gap-2 w-full h-[44px] rounded-full text-[13.5px] font-semibold text-foreground-950 bg-background-100 border border-background-200 whitespace-nowrap transition-all duration-300 group-hover:bg-foreground-950 group-hover:text-background-50 group-hover:border-foreground-950 cursor-pointer">
                View broker
                <i className="ri-arrow-right-up-line text-[15px] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
              </span>
            </a>
          ))}
        </div>

        {/* Bottom note — one line, not a wall of defensive text */}
        <p className="mt-10 text-center text-[12.5px] leading-[20px] text-foreground-400 max-w-[640px] mx-auto">
          These are paid placements and not endorsements. Forex & CFD trading carries significant risk — always review each broker's official terms, pricing, and risk disclosures before trading.
        </p>
      </div>
    </section>
  );
}